var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = /*
                 * Generated by PEG.js 0.10.0.
                 *
                 * http://pegjs.org/
                 */
function () {
  "use strict";

  function peg$subclass(child, parent) {
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  peg$SyntaxError.buildMessage = function (expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
      literal: function literal(expectation) {
        return "\"" + literalEscape(expectation.text) + "\"";
      },

      "class": function _class(expectation) {
        var escapedParts = "",
            i;

        for (i = 0; i < expectation.parts.length; i++) {
          escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
        }

        return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
      },

      any: function any(expectation) {
        return "any character";
      },

      end: function end(expectation) {
        return "end of input";
      },

      other: function other(expectation) {
        return expectation.description;
      }
    };

    function hex(ch) {
      return ch.charCodeAt(0).toString(16).toUpperCase();
    }

    function literalEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function classEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function describeExpectation(expectation) {
      return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }

    function describeExpected(expected) {
      var descriptions = new Array(expected.length),
          i,
          j;

      for (i = 0; i < expected.length; i++) {
        descriptions[i] = describeExpectation(expected[i]);
      }

      descriptions.sort();

      if (descriptions.length > 0) {
        for (i = 1, j = 1; i < descriptions.length; i++) {
          if (descriptions[i - 1] !== descriptions[i]) {
            descriptions[j] = descriptions[i];
            j++;
          }
        }
        descriptions.length = j;
      }

      switch (descriptions.length) {
        case 1:
          return descriptions[0];

        case 2:
          return descriptions[0] + " or " + descriptions[1];

        default:
          return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
      }
    }

    function describeFound(found) {
      return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }

    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  };

  function peg$parse(input, options) {
    options = options !== void 0 ? options : {};

    var peg$FAILED = {},
        peg$startRuleIndices = { formula: 0 },
        peg$startRuleIndex = 0,
        peg$consts = ["=", peg$literalExpectation("=", false), function (ex) {
      return ex;
    }, function (fC, e1) {
      var res = [].concat(fC);
      if (e1 != null && e1 != "EOF") {
        res = res.concat(e1);
      }
      return res;
    }, "(", peg$literalExpectation("(", false), ")", peg$literalExpectation(")", false), function (e, e1) {
      var res = ["("].concat(e).concat(")");
      if (e1 != null && e1 != "EOF") {
        res = res.concat(e1);
      }
      return res;
    }, function (prOp, e, e1) {
      var res = [].concat(prOp).concat(e);
      if (e1 != null && e1 != "EOF") {
        res = res.concat(e1);
      }
      return res;
    }, function (cR, e1) {
      var res = [].concat(cR);
      if (e1 != null && e1 != "EOF") {
        res = res.concat(e1);
      }
      return res;
    }, function (con, e1) {
      var res = [].concat(con);
      if (e1 != null && e1 != "EOF") {
        res = res.concat(e1);
      }
      return res;
    }, function (inOp, e, e1) {
      var res = [].concat(inOp).concat(e);
      if (e1 != null && e1 != "EOF") {
        res = res.concat(e1);
      }
      return res;
    }, function (pOp, e1) {
      var res = [].concat(pOp);
      if (e1 != null && e1 != "EOF") {
        res = res.concat(e1);
      }
      return res;
    }, peg$anyExpectation(), function () {
      return "EOF";
    }, function (arg) {
      return arg;
    }, function (aL) {
      return aL;
    }, function (rB) {
      return ")";
    }, function (fC) {
      return fC;
    }, function () {
      return text();
    }, function (a1, delim, arg) {
      return arg === null ? "cEmpty" : arg;
    }, function (a1, a2) {
      return [].concat(a1).concat(a2);
    }, function (exp) {
      return exp;
    }, function () {
      var _text = text();
      return {
        type: "node",
        name: _text,
        text: _text,
        offset: peg$currPos - _text.length
      };
    }, function (_table) {
      var _name = _table[0],
          _table$ = _table[1],
          _intraTableReference = _table$ === undefined ? [] : _table$;

      var refs = _intraTableReference.flat(Infinity).filter(function (x) {
        return x !== null && x !== undefined;
      });
      var intraTableKeywords = (refs.find(function (t) {
        return (typeof t === "undefined" ? "undefined" : _typeof(t)) === "object" && t.type === "keywordList";
      }) || {}).keywords;
      var intraTableColumnRange = (refs.find(function (t) {
        return (typeof t === "undefined" ? "undefined" : _typeof(t)) === "object" && t.type === "columnRange";
      }) || {}).columns;
      var intraTableStruct = {
        keywords: intraTableKeywords || [],
        columns: intraTableColumnRange || []
      };

      return {
        type: "table",
        name: _name,
        intraTableReference: refs,
        intraTableStruct: intraTableStruct,
        text: text(),
        offset: peg$currPos - text().length
      };
    }, function (_intraTableReference) {
      return _intraTableReference;
    }, function (_innerReference) {
      return _innerReference;
    }, "[#headers]", peg$literalExpectation("[#Headers]", true), "[#data]", peg$literalExpectation("[#Data]", true), "[#Data]", peg$literalExpectation("[#Data]", false), "[#totals]", peg$literalExpectation("[#Totals]", true), function () {
      var _text = text();
      return {
        type: "keywordList",
        keywords: _text.split(",").map(function (t) {
          return t.trim();
        }),
        text: _text,
        offset: peg$currPos - text().length
      };
    }, function () {
      var _text = text();
      return {
        type: "keywordList",
        keywords: [_text],
        text: _text,
        offset: peg$currPos - _text.length
      };
    }, "[#all]", peg$literalExpectation("[#All]", true), "[#this row]", peg$literalExpectation("[#This Row]", true), ":", peg$literalExpectation(":", false), function (col) {
      var tokens = col.flat(Infinity).filter(function (x) {
        return x !== null && x !== undefined && x !== [];
      });
      var columns = tokens.filter(function (t) {
        return (typeof t === "undefined" ? "undefined" : _typeof(t)) === "object" && t.type === "column";
      });

      var _text = text();
      return {
        type: "columnRange",
        tokens: tokens,
        columns: columns,
        text: _text,
        offset: peg$currPos - _text.length
      };
    }, "[", peg$literalExpectation("[", false), "]", peg$literalExpectation("]", false), function () {
      var _text = text();
      return {
        type: "column",
        name: _text,
        text: _text,
        offset: peg$currPos - _text.length
      };
    }, "#", peg$literalExpectation("#", false), /^[']/, peg$classExpectation(["'"], false, false), function (cnst) {
      return cnst + "";
    }, "#div/0!", peg$literalExpectation("#DIV/0!", true), "#n/a", peg$literalExpectation("#N/A", true), "#name?", peg$literalExpectation("#NAME?", true), "#null!", peg$literalExpectation("#NULL!", true), "#num!", peg$literalExpectation("#NUM!", true), "#ref!", peg$literalExpectation("#REF!", true), "#value!", peg$literalExpectation("#VALUE!", true), "#getting_data", peg$literalExpectation("#GETTING_DATA", true), function () {
      return text(); /*erroconst do something*/
    }, "true", peg$literalExpectation("TRUE", true), "false", peg$literalExpectation("FALSE", true), function () {
      return text(); /*logconst do something*/
    }, function (d1, sc, d2) {
      return text(); /*strconst do something*/
    }, "\"", peg$literalExpectation("\"", false), /^[\t\n\r !#-\uD7FF\uE000-\uFFFD]/, peg$classExpectation(["\t", "\n", "\r", " ", "!", ["#", "\uD7FF"], ["\uE000", "\uFFFD"]], false, false), /^[^\0-\uFFFF]/, peg$classExpectation([["\0", "\uFFFF"]], true, false), "\"\"", peg$literalExpectation("\"\"", false), ".", peg$literalExpectation(".", false), function () {
      return text(); /*numconst do something*/
    }, "0", peg$literalExpectation("0", false), /^[+\-]/, peg$classExpectation(["+", "-"], false, false), /^[1-9]/, peg$classExpectation([["1", "9"]], false, false), "e", peg$literalExpectation("e", true), /^[0-9]/, peg$classExpectation([["0", "9"]], false, false), "{", peg$literalExpectation("{", false), "}", peg$literalExpectation("}", false), ";", peg$literalExpectation(";", false), function (c) {
      return c === null ? "cEmpty" : c;
    }, "^", peg$literalExpectation("^", false), "*", peg$literalExpectation("*", false), "/", peg$literalExpectation("/", false), "+", peg$literalExpectation("+", false), "-", peg$literalExpectation("-", false), "&", peg$literalExpectation("&", false), "<>", peg$literalExpectation("<>", false), "<", peg$literalExpectation("<", false), "<=", peg$literalExpectation("<=", false), ">", peg$literalExpectation(">", false), ">=", peg$literalExpectation(">=", false), "%", peg$literalExpectation("%", false), function (op) {
      return op;
    }, ",", peg$literalExpectation(",", false), " ", peg$literalExpectation(" ", false), "_", peg$literalExpectation("_", false), "\\", peg$literalExpectation("\\", false), /^[A-Za-z_\x80-\x81\x83\x85-\x87\x89-\x8A\x8C-\x91\x93-\x94\x96-\x97\x99-\x9A\x9C-\x9F\xA1-\xA5\xA7-\xA8\xAA\xAD\xAF-\xBA\xBC-\u02B8\u02BB-\u02C1\u02C7\u02C9-\u02CB\u02CD\u02D0-\u02D1\u02D8-\u02DB\u02DD\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0523\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0621-\u064A\u066E-\u066F\u0671-\u06D3\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4-\u07F5\u07FA\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0972\u097B-\u097F\u0985-\u098C\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC-\u09DD\u09DF-\u09E1\u09F0-\u09F1\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33\u0A35-\u0A36\u0A38-\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0-\u0AE1\u0B05-\u0B0C\u0B0F-\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B5C-\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58-\u0C59\u0C60-\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0-\u0CE1\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D28\u0D2A-\u0D39\u0D3D\u0D60-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E3A\u0E40-\u0E4E\u0E81-\u0E82\u0E84\u0E87-\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDD\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8B\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065-\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10D0-\u10FA\u10FC\u1100-\u1159\u115F-\u11A2\u11A8-\u11F9\u1200-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u1676\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F0\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19A9\u19C1-\u19C7\u1A00-\u1A16\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE-\u1BAF\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2010\u2013-\u2016\u2018\u201C-\u201D\u2020-\u2021\u2025-\u2027\u2030\u2032-\u2033\u2035\u203B\u2071\u2074\u207F\u2081-\u2084\u2090-\u2094\u2102-\u2103\u2105\u2107\u2109-\u2113\u2115-\u2116\u2119-\u211D\u2121-\u2122\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2153-\u2154\u215B-\u215E\u2160-\u2188\u2190-\u2199\u21D2\u21D4\u2200\u2202-\u2203\u2207-\u2208\u220B\u220F\u2211\u2215\u221A\u221D-\u2220\u2223\u2225\u2227-\u222C\u222E\u2234-\u2237\u223C-\u223D\u2248\u224C\u2252\u2260-\u2261\u2264-\u2267\u226A-\u226B\u226E-\u226F\u2282-\u2283\u2286-\u2287\u2295\u2299\u22A5\u22BF\u2312\u2460-\u24B5\u24D0-\u24E9\u2500-\u254B\u2550-\u2574\u2581-\u258F\u2592-\u2595\u25A0-\u25A1\u25A3-\u25A9\u25B2-\u25B3\u25B6-\u25B7\u25BC-\u25BD\u25C0-\u25C1\u25C6-\u25C8\u25CB\u25CE-\u25D1\u25E2-\u25E5\u25EF\u2605-\u2606\u2609\u260E-\u260F\u261C\u261E\u2640\u2642\u2660-\u2661\u2663-\u2665\u2667-\u266A\u266C-\u266D\u266F\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C6F\u2C71-\u2C7D\u2C80-\u2CE4\u2D00-\u2D25\u2D30-\u2D65\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3000-\u3003\u3005-\u3017\u301D-\u301F\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31B7\u31F0-\u321C\u3220-\u3229\u3231-\u3232\u3239\u3260-\u327B\u327F\u32A3-\u32A8\u3303\u330D\u3314\u3318\u3322-\u3323\u3326-\u3327\u332B\u3336\u333B\u3349-\u334A\u334D\u3351\u3357\u337B-\u337E\u3380-\u3384\u3388-\u33CA\u33CD-\u33D3\u33D5-\u33D6\u33D8\u33DB-\u33DD\u3400-\u4DB5\u4E00-\u9FC3\uA000-\uA48C\uA500-\uA60C\uA610-\uA61F\uA62A-\uA62B\uA640-\uA65F\uA662-\uA66E\uA680-\uA697\uA722-\uA787\uA78B-\uA78C\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA90A-\uA925\uA930-\uA946\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAC00-\uD7A3\uE000-\uF848\uF900-\uFA2D\uFA30-\uFA6A\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40-\uFB41\uFB43-\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE30-\uFE31\uFE33-\uFE44\uFE49-\uFE52\uFE54-\uFE57\uFE59-\uFE66\uFE68-\uFE6B\uFE70-\uFE74\uFE76-\uFEFC\uFF01-\uFF5E\uFF61-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC\uFFE0-\uFFE6]/i, peg$classExpectation([["A", "Z"], ["a", "z"], "_", ["\x80", "\x81"], "\x83", ["\x85", "\x87"], ["\x89", "\x8A"], ["\x8C", "\x91"], ["\x93", "\x94"], ["\x96", "\x97"], ["\x99", "\x9A"], ["\x9C", "\x9F"], ["\xA1", "\xA5"], ["\xA7", "\xA8"], "\xAA", "\xAD", ["\xAF", "\xBA"], ["\xBC", "\u02B8"], ["\u02BB", "\u02C1"], "\u02C7", ["\u02C9", "\u02CB"], "\u02CD", ["\u02D0", "\u02D1"], ["\u02D8", "\u02DB"], "\u02DD", ["\u02E0", "\u02E4"], "\u02EE", ["\u0370", "\u0373"], ["\u0376", "\u0377"], ["\u037A", "\u037D"], "\u0386", ["\u0388", "\u038A"], "\u038C", ["\u038E", "\u03A1"], ["\u03A3", "\u03F5"], ["\u03F7", "\u0481"], ["\u048A", "\u0523"], ["\u0531", "\u0556"], "\u0559", ["\u0561", "\u0587"], ["\u05D0", "\u05EA"], ["\u05F0", "\u05F2"], ["\u0621", "\u064A"], ["\u066E", "\u066F"], ["\u0671", "\u06D3"], "\u06D5", ["\u06E5", "\u06E6"], ["\u06EE", "\u06EF"], ["\u06FA", "\u06FC"], "\u06FF", "\u0710", ["\u0712", "\u072F"], ["\u074D", "\u07A5"], "\u07B1", ["\u07CA", "\u07EA"], ["\u07F4", "\u07F5"], "\u07FA", ["\u0904", "\u0939"], "\u093D", "\u0950", ["\u0958", "\u0961"], ["\u0971", "\u0972"], ["\u097B", "\u097F"], ["\u0985", "\u098C"], ["\u098F", "\u0990"], ["\u0993", "\u09A8"], ["\u09AA", "\u09B0"], "\u09B2", ["\u09B6", "\u09B9"], "\u09BD", "\u09CE", ["\u09DC", "\u09DD"], ["\u09DF", "\u09E1"], ["\u09F0", "\u09F1"], ["\u0A05", "\u0A0A"], ["\u0A0F", "\u0A10"], ["\u0A13", "\u0A28"], ["\u0A2A", "\u0A30"], ["\u0A32", "\u0A33"], ["\u0A35", "\u0A36"], ["\u0A38", "\u0A39"], ["\u0A59", "\u0A5C"], "\u0A5E", ["\u0A72", "\u0A74"], ["\u0A85", "\u0A8D"], ["\u0A8F", "\u0A91"], ["\u0A93", "\u0AA8"], ["\u0AAA", "\u0AB0"], ["\u0AB2", "\u0AB3"], ["\u0AB5", "\u0AB9"], "\u0ABD", "\u0AD0", ["\u0AE0", "\u0AE1"], ["\u0B05", "\u0B0C"], ["\u0B0F", "\u0B10"], ["\u0B13", "\u0B28"], ["\u0B2A", "\u0B30"], ["\u0B32", "\u0B33"], ["\u0B35", "\u0B39"], "\u0B3D", ["\u0B5C", "\u0B5D"], ["\u0B5F", "\u0B61"], "\u0B71", "\u0B83", ["\u0B85", "\u0B8A"], ["\u0B8E", "\u0B90"], ["\u0B92", "\u0B95"], ["\u0B99", "\u0B9A"], "\u0B9C", ["\u0B9E", "\u0B9F"], ["\u0BA3", "\u0BA4"], ["\u0BA8", "\u0BAA"], ["\u0BAE", "\u0BB9"], "\u0BD0", ["\u0C05", "\u0C0C"], ["\u0C0E", "\u0C10"], ["\u0C12", "\u0C28"], ["\u0C2A", "\u0C33"], ["\u0C35", "\u0C39"], "\u0C3D", ["\u0C58", "\u0C59"], ["\u0C60", "\u0C61"], ["\u0C85", "\u0C8C"], ["\u0C8E", "\u0C90"], ["\u0C92", "\u0CA8"], ["\u0CAA", "\u0CB3"], ["\u0CB5", "\u0CB9"], "\u0CBD", "\u0CDE", ["\u0CE0", "\u0CE1"], ["\u0D05", "\u0D0C"], ["\u0D0E", "\u0D10"], ["\u0D12", "\u0D28"], ["\u0D2A", "\u0D39"], "\u0D3D", ["\u0D60", "\u0D61"], ["\u0D7A", "\u0D7F"], ["\u0D85", "\u0D96"], ["\u0D9A", "\u0DB1"], ["\u0DB3", "\u0DBB"], "\u0DBD", ["\u0DC0", "\u0DC6"], ["\u0E01", "\u0E3A"], ["\u0E40", "\u0E4E"], ["\u0E81", "\u0E82"], "\u0E84", ["\u0E87", "\u0E88"], "\u0E8A", "\u0E8D", ["\u0E94", "\u0E97"], ["\u0E99", "\u0E9F"], ["\u0EA1", "\u0EA3"], "\u0EA5", "\u0EA7", ["\u0EAA", "\u0EAB"], ["\u0EAD", "\u0EB0"], ["\u0EB2", "\u0EB3"], "\u0EBD", ["\u0EC0", "\u0EC4"], "\u0EC6", ["\u0EDC", "\u0EDD"], "\u0F00", ["\u0F40", "\u0F47"], ["\u0F49", "\u0F6C"], ["\u0F88", "\u0F8B"], ["\u1000", "\u102A"], "\u103F", ["\u1050", "\u1055"], ["\u105A", "\u105D"], "\u1061", ["\u1065", "\u1066"], ["\u106E", "\u1070"], ["\u1075", "\u1081"], "\u108E", ["\u10A0", "\u10C5"], ["\u10D0", "\u10FA"], "\u10FC", ["\u1100", "\u1159"], ["\u115F", "\u11A2"], ["\u11A8", "\u11F9"], ["\u1200", "\u1248"], ["\u124A", "\u124D"], ["\u1250", "\u1256"], "\u1258", ["\u125A", "\u125D"], ["\u1260", "\u1288"], ["\u128A", "\u128D"], ["\u1290", "\u12B0"], ["\u12B2", "\u12B5"], ["\u12B8", "\u12BE"], "\u12C0", ["\u12C2", "\u12C5"], ["\u12C8", "\u12D6"], ["\u12D8", "\u1310"], ["\u1312", "\u1315"], ["\u1318", "\u135A"], ["\u1380", "\u138F"], ["\u13A0", "\u13F4"], ["\u1401", "\u166C"], ["\u166F", "\u1676"], ["\u1681", "\u169A"], ["\u16A0", "\u16EA"], ["\u16EE", "\u16F0"], ["\u1700", "\u170C"], ["\u170E", "\u1711"], ["\u1720", "\u1731"], ["\u1740", "\u1751"], ["\u1760", "\u176C"], ["\u176E", "\u1770"], ["\u1780", "\u17B3"], "\u17D7", "\u17DC", ["\u1820", "\u1877"], ["\u1880", "\u18A8"], "\u18AA", ["\u1900", "\u191C"], ["\u1950", "\u196D"], ["\u1970", "\u1974"], ["\u1980", "\u19A9"], ["\u19C1", "\u19C7"], ["\u1A00", "\u1A16"], ["\u1B05", "\u1B33"], ["\u1B45", "\u1B4B"], ["\u1B83", "\u1BA0"], ["\u1BAE", "\u1BAF"], ["\u1C00", "\u1C23"], ["\u1C4D", "\u1C4F"], ["\u1C5A", "\u1C7D"], ["\u1D00", "\u1DBF"], ["\u1E00", "\u1F15"], ["\u1F18", "\u1F1D"], ["\u1F20", "\u1F45"], ["\u1F48", "\u1F4D"], ["\u1F50", "\u1F57"], "\u1F59", "\u1F5B", "\u1F5D", ["\u1F5F", "\u1F7D"], ["\u1F80", "\u1FB4"], ["\u1FB6", "\u1FBC"], "\u1FBE", ["\u1FC2", "\u1FC4"], ["\u1FC6", "\u1FCC"], ["\u1FD0", "\u1FD3"], ["\u1FD6", "\u1FDB"], ["\u1FE0", "\u1FEC"], ["\u1FF2", "\u1FF4"], ["\u1FF6", "\u1FFC"], "\u2010", ["\u2013", "\u2016"], "\u2018", ["\u201C", "\u201D"], ["\u2020", "\u2021"], ["\u2025", "\u2027"], "\u2030", ["\u2032", "\u2033"], "\u2035", "\u203B", "\u2071", "\u2074", "\u207F", ["\u2081", "\u2084"], ["\u2090", "\u2094"], ["\u2102", "\u2103"], "\u2105", "\u2107", ["\u2109", "\u2113"], ["\u2115", "\u2116"], ["\u2119", "\u211D"], ["\u2121", "\u2122"], "\u2124", "\u2126", "\u2128", ["\u212A", "\u212D"], ["\u212F", "\u2139"], ["\u213C", "\u213F"], ["\u2145", "\u2149"], "\u214E", ["\u2153", "\u2154"], ["\u215B", "\u215E"], ["\u2160", "\u2188"], ["\u2190", "\u2199"], "\u21D2", "\u21D4", "\u2200", ["\u2202", "\u2203"], ["\u2207", "\u2208"], "\u220B", "\u220F", "\u2211", "\u2215", "\u221A", ["\u221D", "\u2220"], "\u2223", "\u2225", ["\u2227", "\u222C"], "\u222E", ["\u2234", "\u2237"], ["\u223C", "\u223D"], "\u2248", "\u224C", "\u2252", ["\u2260", "\u2261"], ["\u2264", "\u2267"], ["\u226A", "\u226B"], ["\u226E", "\u226F"], ["\u2282", "\u2283"], ["\u2286", "\u2287"], "\u2295", "\u2299", "\u22A5", "\u22BF", "\u2312", ["\u2460", "\u24B5"], ["\u24D0", "\u24E9"], ["\u2500", "\u254B"], ["\u2550", "\u2574"], ["\u2581", "\u258F"], ["\u2592", "\u2595"], ["\u25A0", "\u25A1"], ["\u25A3", "\u25A9"], ["\u25B2", "\u25B3"], ["\u25B6", "\u25B7"], ["\u25BC", "\u25BD"], ["\u25C0", "\u25C1"], ["\u25C6", "\u25C8"], "\u25CB", ["\u25CE", "\u25D1"], ["\u25E2", "\u25E5"], "\u25EF", ["\u2605", "\u2606"], "\u2609", ["\u260E", "\u260F"], "\u261C", "\u261E", "\u2640", "\u2642", ["\u2660", "\u2661"], ["\u2663", "\u2665"], ["\u2667", "\u266A"], ["\u266C", "\u266D"], "\u266F", ["\u2C00", "\u2C2E"], ["\u2C30", "\u2C5E"], ["\u2C60", "\u2C6F"], ["\u2C71", "\u2C7D"], ["\u2C80", "\u2CE4"], ["\u2D00", "\u2D25"], ["\u2D30", "\u2D65"], "\u2D6F", ["\u2D80", "\u2D96"], ["\u2DA0", "\u2DA6"], ["\u2DA8", "\u2DAE"], ["\u2DB0", "\u2DB6"], ["\u2DB8", "\u2DBE"], ["\u2DC0", "\u2DC6"], ["\u2DC8", "\u2DCE"], ["\u2DD0", "\u2DD6"], ["\u2DD8", "\u2DDE"], ["\u3000", "\u3003"], ["\u3005", "\u3017"], ["\u301D", "\u301F"], ["\u3021", "\u3029"], ["\u3031", "\u3035"], ["\u3038", "\u303C"], ["\u3041", "\u3096"], ["\u309B", "\u309F"], ["\u30A1", "\u30FF"], ["\u3105", "\u312D"], ["\u3131", "\u318E"], ["\u31A0", "\u31B7"], ["\u31F0", "\u321C"], ["\u3220", "\u3229"], ["\u3231", "\u3232"], "\u3239", ["\u3260", "\u327B"], "\u327F", ["\u32A3", "\u32A8"], "\u3303", "\u330D", "\u3314", "\u3318", ["\u3322", "\u3323"], ["\u3326", "\u3327"], "\u332B", "\u3336", "\u333B", ["\u3349", "\u334A"], "\u334D", "\u3351", "\u3357", ["\u337B", "\u337E"], ["\u3380", "\u3384"], ["\u3388", "\u33CA"], ["\u33CD", "\u33D3"], ["\u33D5", "\u33D6"], "\u33D8", ["\u33DB", "\u33DD"], ["\u3400", "\u4DB5"], ["\u4E00", "\u9FC3"], ["\uA000", "\uA48C"], ["\uA500", "\uA60C"], ["\uA610", "\uA61F"], ["\uA62A", "\uA62B"], ["\uA640", "\uA65F"], ["\uA662", "\uA66E"], ["\uA680", "\uA697"], ["\uA722", "\uA787"], ["\uA78B", "\uA78C"], ["\uA7FB", "\uA801"], ["\uA803", "\uA805"], ["\uA807", "\uA80A"], ["\uA80C", "\uA822"], ["\uA840", "\uA873"], ["\uA882", "\uA8B3"], ["\uA90A", "\uA925"], ["\uA930", "\uA946"], ["\uAA00", "\uAA28"], ["\uAA40", "\uAA42"], ["\uAA44", "\uAA4B"], ["\uAC00", "\uD7A3"], ["\uE000", "\uF848"], ["\uF900", "\uFA2D"], ["\uFA30", "\uFA6A"], ["\uFA70", "\uFAD9"], ["\uFB00", "\uFB06"], ["\uFB13", "\uFB17"], "\uFB1D", ["\uFB1F", "\uFB28"], ["\uFB2A", "\uFB36"], ["\uFB38", "\uFB3C"], "\uFB3E", ["\uFB40", "\uFB41"], ["\uFB43", "\uFB44"], ["\uFB46", "\uFBB1"], ["\uFBD3", "\uFD3D"], ["\uFD50", "\uFD8F"], ["\uFD92", "\uFDC7"], ["\uFDF0", "\uFDFB"], ["\uFE30", "\uFE31"], ["\uFE33", "\uFE44"], ["\uFE49", "\uFE52"], ["\uFE54", "\uFE57"], ["\uFE59", "\uFE66"], ["\uFE68", "\uFE6B"], ["\uFE70", "\uFE74"], ["\uFE76", "\uFEFC"], ["\uFF01", "\uFF5E"], ["\uFF61", "\uFFBE"], ["\uFFC2", "\uFFC7"], ["\uFFCA", "\uFFCF"], ["\uFFD2", "\uFFD7"], ["\uFFDA", "\uFFDC"], ["\uFFE0", "\uFFE6"]], false, true)],
        peg$bytecode = [peg$decode("%2 \"\"6 7!.\" &\"/A#$;U0#*;U&/1$;!/($8#:\"#! )(#'#(\"'#&'#"), peg$decode("%;$/=#;\".( &;#.\" &\"/)$8\":#\"\"! )(\"'#&'#.\xED &%2$\"\"6$7%/U#;!/L$2&\"\"6&7'/=$;\".( &;#.\" &\"/)$8$:($\"\" )($'#(#'#(\"'#&'#.\xA5 &%;S/G#;!/>$;\".( &;#.\" &\"/*$8#:)##\"! )(#'#(\"'#&'#.q &%;)/=#;\".( &;#.\" &\"/)$8\":*\"\"! )(\"'#&'#.G &%;</=#;\".( &;#.\" &\"/)$8\":+\"\"! )(\"'#&'#"), peg$decode("%;Q/G#;!/>$;\".( &;#.\" &\"/*$8#:,##\"! )(#'#(\"'#&'#.G &%;R/=#;\".( &;#.\" &\"/)$8\":-\"\"! )(\"'#&'#"), peg$decode("%%<1\"\"5!7.=.##&&!&'#/& 8!:/! )"), peg$decode("%$;U0#*;U&/\x90#%;%/x#2$\"\"6$7%/i$%%;'.\" &\"/' 8!:0!! )/' 8!:1!! )/C$%2&\"\"6&7'.\" &\"/' 8!:2!! )/#$+$)($'#(#'#(\"'#&'#/($8\":3\"! )(\"'#&'#"), peg$decode("%%;[/3#$;&0#*;&&/#$+\")(\"'#&'#/& 8!:4! )"), peg$decode(";[.) &;H.# &;J"), peg$decode("%;(/\x83#$%;T.# &;N/8#;(.\" &\"/*$8\":5\"#$! )(\"'#&'#0H*%;T.# &;N/8#;(.\" &\"/*$8\":5\"#$! )(\"'#&'#&/)$8\":6\"\"! )(\"'#&'#"), peg$decode("%$;U0#*;U&/A#;!/8$$;U0#*;U&/($8#:7#!!)(#'#(\"'#&'#"), peg$decode(";*.. &%;8/& 8!:8! )"), peg$decode("%%;8/,#;+/#$+\")(\"'#&'#/' 8!:9!! )"), peg$decode("%%;6/5#;,/,$;7/#$+#)(#'#(\"'#&'#/' 8!::!! )"), peg$decode("%%%;-/,#;5/#$+\")(\"'#&'#.\" &\"/,#;//#$+\")(\"'#&'#/' 8!:;!! ).# &;-"), peg$decode("%%3<\"\"5*7=/;#;5/2$3>\"\"5'7?/#$+#)(#'#(\"'#&'#.K &%2@\"\"6@7A/;#;5/2$3B\"\"5)7C/#$+#)(#'#(\"'#&'#/& 8!:D! ).. &%;./& 8!:E! )"), peg$decode("3F\"\"5&7G.M &3>\"\"5'7?.A &3<\"\"5*7=.5 &3B\"\"5)7C.) &3H\"\"5+7I"), peg$decode("%%;0/J#%2J\"\"6J7K/,#;0/#$+\")(\"'#&'#.\" &\"/#$+\")(\"'#&'#/' 8!:L!! )"), peg$decode("%2M\"\"6M7N/[#$;U0#*;U&/K$;1/B$$;U0#*;U&/2$2O\"\"6O7P/#$+%)(%'#($'#(#'#(\"'#&'#.# &;1"), peg$decode("%$;20#*;2&/& 8!:Q! )"), peg$decode(";[.B &%;4/,#;3/#$+\")(\"'#&'#.) &;U.# &;H"), peg$decode(";4.A &2M\"\"6M7N.5 &2O\"\"6O7P.) &2R\"\"6R7S"), peg$decode("4T\"\"5!7U"), peg$decode("%;U.\" &\"/:#;T/1$;U.\" &\"/#$+#)(#'#(\"'#&'#"), peg$decode("%2M\"\"6M7N/1#;U.\" &\"/#$+\")(\"'#&'#"), peg$decode("%;U.\" &\"/2#2O\"\"6O7P/#$+\")(\"'#&'#"), peg$decode("%%;9/1#;:.\" &\"/#$+\")(\"'#&'#/& 8!:4! )"), peg$decode(";[.) &;V.# &;W"), peg$decode("%$;;/&#0#*;;&&&#/& 8!:4! )"), peg$decode(";[./ &;H.) &;V.# &;J"), peg$decode("%$;U0#*;U&/Y#;=.5 &;>./ &;?.) &;B.# &;L/8$$;U0#*;U&/($8#:V#!!)(#'#(\"'#&'#"), peg$decode("%3W\"\"5'7X.q &3Y\"\"5$7Z.e &3[\"\"5&7\\.Y &3]\"\"5&7^.M &3_\"\"5%7`.A &3a\"\"5%7b.5 &3c\"\"5'7d.) &3e\"\"5-7f/& 8!:g! )"), peg$decode("3h\"\"5$7i.4 &%3j\"\"5%7k/& 8!:l! )"), peg$decode("%;@/A#;A.\" &\"/3$;@/*$8#:m##\"! )(#'#(\"'#&'#"), peg$decode("2n\"\"6n7o"), peg$decode("%$4p\"\"5!7q.) &4r\"\"5!7s.) &2t\"\"6t7u/D#0A*4p\"\"5!7q.) &4r\"\"5!7s.) &2t\"\"6t7u&&&#/& 8!:4! )"), peg$decode("%%;C/P#2v\"\"6v7w/A$$;H0#*;H&/1$;F.\" &\"/#$+$)($'#(#'#(\"'#&'#.u &%2v\"\"6v7w/G#$;H/&#0#*;H&&&#/1$;F.\" &\"/#$+#)(#'#(\"'#&'#.; &%;C/1#;F.\" &\"/#$+\")(\"'#&'#/& 8!:x! )"), peg$decode("2y\"\"6y7z.= &%;D/3#$;H0#*;H&/#$+\")(\"'#&'#"), peg$decode("%4{\"\"5!7|.\" &\"/,#;E/#$+\")(\"'#&'#"), peg$decode("4}\"\"5!7~"), peg$decode("%3\x7F\"\"5!7\x80/,#;G/#$+\")(\"'#&'#"), peg$decode("%4{\"\"5!7|.\" &\"/9#$;H/&#0#*;H&&&#/#$+\")(\"'#&'#"), peg$decode("4\x81\"\"5!7\x82"), peg$decode("%$;H/&#0#*;H&&&#/& 8!:4! )"), peg$decode("2v\"\"6v7w"), peg$decode(";U.\" &\""), peg$decode("%2\x83\"\"6\x837\x84/H#$;M/&#0#*;M&&&#/2$2\x85\"\"6\x857\x86/#$+#)(#'#(\"'#&'#"), peg$decode("%;O/c#$%;N/1#;O.\" &\"/#$+\")(\"'#&'#0;*%;N/1#;O.\" &\"/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"), peg$decode("2\x87\"\"6\x877\x88"), peg$decode("%;</m#$%;T/6#;<.\" &\"/($8\":\x89\"! )(\"'#&'#0@*%;T/6#;<.\" &\"/($8\":\x89\"! )(\"'#&'#&/#$+\")(\"'#&'#"), peg$decode("%$;U0#*;U&/\xEF#2J\"\"6J7K.\xC5 &;T.\xBF &;U.\xB9 &2\x8A\"\"6\x8A7\x8B.\xAD &2\x8C\"\"6\x8C7\x8D.\xA1 &2\x8E\"\"6\x8E7\x8F.\x95 &2\x90\"\"6\x907\x91.\x89 &2\x92\"\"6\x927\x93.} &2\x94\"\"6\x947\x95.q &2 \"\"6 7!.e &2\x96\"\"6\x967\x97.Y &2\x98\"\"6\x987\x99.M &2\x9A\"\"6\x9A7\x9B.A &2\x9C\"\"6\x9C7\x9D.5 &2\x9E\"\"6\x9E7\x9F.) &2\xA0\"\"6\xA07\xA1/8$$;U0#*;U&/($8#:\xA2#!!)(#'#(\"'#&'#"), peg$decode("%$;U0#*;U&/\xE3#2J\"\"6J7K.\xB9 &;T.\xB3 &;U.\xAD &2\x8A\"\"6\x8A7\x8B.\xA1 &2\x8C\"\"6\x8C7\x8D.\x95 &2\x8E\"\"6\x8E7\x8F.\x89 &2\x90\"\"6\x907\x91.} &2\x92\"\"6\x927\x93.q &2\x94\"\"6\x947\x95.e &2 \"\"6 7!.Y &2\x96\"\"6\x967\x97.M &2\x98\"\"6\x987\x99.A &2\x9A\"\"6\x9A7\x9B.5 &2\x9C\"\"6\x9C7\x9D.) &2\x9E\"\"6\x9E7\x9F/8$$;U0#*;U&/($8#:\xA2#!!)(#'#(\"'#&'#"), peg$decode("%$;U0#*;U&/G#2\xA0\"\"6\xA07\xA1/8$$;U0#*;U&/($8#:\xA2#!!)(#'#(\"'#&'#"), peg$decode("%$;U0#*;U&/S#2\x92\"\"6\x927\x93.) &2\x90\"\"6\x907\x91/8$$;U0#*;U&/($8#:\xA2#!!)(#'#(\"'#&'#"), peg$decode("2\xA3\"\"6\xA37\xA4"), peg$decode("2\xA5\"\"6\xA57\xA6"), peg$decode("2\xA7\"\"6\xA77\xA8"), peg$decode("2\xA9\"\"6\xA97\xAA"), peg$decode("2$\"\"6$7%"), peg$decode("2&\"\"6&7'"), peg$decode("%$;[/&#0#*;[&&&#/& 8!:4! )"), peg$decode("4\xAB\"\"5!7\xAC")],
        peg$currPos = 0,
        peg$savedPos = 0,
        peg$posDetailsCache = [{ line: 1, column: 1 }],
        peg$maxFailPos = 0,
        peg$maxFailExpected = [],
        peg$silentFails = 0,
        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleIndices)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleIndex = peg$startRuleIndices[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description, location) {
      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);

      throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
    }

    function error(message, location) {
      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);

      throw peg$buildSimpleError(message, location);
    }

    function peg$literalExpectation(text, ignoreCase) {
      return { type: "literal", text: text, ignoreCase: ignoreCase };
    }

    function peg$classExpectation(parts, inverted, ignoreCase) {
      return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
    }

    function peg$anyExpectation() {
      return { type: "any" };
    }

    function peg$endExpectation() {
      return { type: "end" };
    }

    function peg$otherExpectation(description) {
      return { type: "other", description: description };
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line: details.line,
          column: details.column
        };

        while (p < pos) {
          if (input.charCodeAt(p) === 10) {
            details.line++;
            details.column = 1;
          } else {
            details.column++;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line: startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line: endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) {
        return;
      }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildSimpleError(message, location) {
      return new peg$SyntaxError(message, null, null, location);
    }

    function peg$buildStructuredError(expected, found, location) {
      return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }

    function peg$decode(s) {
      var bc = new Array(s.length),
          i;

      for (i = 0; i < s.length; i++) {
        bc[i] = s.charCodeAt(i) - 32;
      }

      return bc;
    }

    function peg$parseRule(index) {
      var bc = peg$bytecode[index],
          ip = 0,
          ips = [],
          end = bc.length,
          ends = [],
          stack = [],
          params,
          i;

      while (true) {
        while (ip < end) {
          switch (bc[ip]) {
            case 0:
              stack.push(peg$consts[bc[ip + 1]]);
              ip += 2;
              break;

            case 1:
              stack.push(void 0);
              ip++;
              break;

            case 2:
              stack.push(null);
              ip++;
              break;

            case 3:
              stack.push(peg$FAILED);
              ip++;
              break;

            case 4:
              stack.push([]);
              ip++;
              break;

            case 5:
              stack.push(peg$currPos);
              ip++;
              break;

            case 6:
              stack.pop();
              ip++;
              break;

            case 7:
              peg$currPos = stack.pop();
              ip++;
              break;

            case 8:
              stack.length -= bc[ip + 1];
              ip += 2;
              break;

            case 9:
              stack.splice(-2, 1);
              ip++;
              break;

            case 10:
              stack[stack.length - 2].push(stack.pop());
              ip++;
              break;

            case 11:
              stack.push(stack.splice(stack.length - bc[ip + 1], bc[ip + 1]));
              ip += 2;
              break;

            case 12:
              stack.push(input.substring(stack.pop(), peg$currPos));
              ip++;
              break;

            case 13:
              ends.push(end);
              ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

              if (stack[stack.length - 1]) {
                end = ip + 3 + bc[ip + 1];
                ip += 3;
              } else {
                end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                ip += 3 + bc[ip + 1];
              }

              break;

            case 14:
              ends.push(end);
              ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

              if (stack[stack.length - 1] === peg$FAILED) {
                end = ip + 3 + bc[ip + 1];
                ip += 3;
              } else {
                end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                ip += 3 + bc[ip + 1];
              }

              break;

            case 15:
              ends.push(end);
              ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

              if (stack[stack.length - 1] !== peg$FAILED) {
                end = ip + 3 + bc[ip + 1];
                ip += 3;
              } else {
                end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                ip += 3 + bc[ip + 1];
              }

              break;

            case 16:
              if (stack[stack.length - 1] !== peg$FAILED) {
                ends.push(end);
                ips.push(ip);

                end = ip + 2 + bc[ip + 1];
                ip += 2;
              } else {
                ip += 2 + bc[ip + 1];
              }

              break;

            case 17:
              ends.push(end);
              ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

              if (input.length > peg$currPos) {
                end = ip + 3 + bc[ip + 1];
                ip += 3;
              } else {
                end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                ip += 3 + bc[ip + 1];
              }

              break;

            case 18:
              ends.push(end);
              ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

              if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length) === peg$consts[bc[ip + 1]]) {
                end = ip + 4 + bc[ip + 2];
                ip += 4;
              } else {
                end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                ip += 4 + bc[ip + 2];
              }

              break;

            case 19:
              ends.push(end);
              ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

              if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length).toLowerCase() === peg$consts[bc[ip + 1]]) {
                end = ip + 4 + bc[ip + 2];
                ip += 4;
              } else {
                end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                ip += 4 + bc[ip + 2];
              }

              break;

            case 20:
              ends.push(end);
              ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

              if (peg$consts[bc[ip + 1]].test(input.charAt(peg$currPos))) {
                end = ip + 4 + bc[ip + 2];
                ip += 4;
              } else {
                end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                ip += 4 + bc[ip + 2];
              }

              break;

            case 21:
              stack.push(input.substr(peg$currPos, bc[ip + 1]));
              peg$currPos += bc[ip + 1];
              ip += 2;
              break;

            case 22:
              stack.push(peg$consts[bc[ip + 1]]);
              peg$currPos += peg$consts[bc[ip + 1]].length;
              ip += 2;
              break;

            case 23:
              stack.push(peg$FAILED);
              if (peg$silentFails === 0) {
                peg$fail(peg$consts[bc[ip + 1]]);
              }
              ip += 2;
              break;

            case 24:
              peg$savedPos = stack[stack.length - 1 - bc[ip + 1]];
              ip += 2;
              break;

            case 25:
              peg$savedPos = peg$currPos;
              ip++;
              break;

            case 26:
              params = bc.slice(ip + 4, ip + 4 + bc[ip + 3]);
              for (i = 0; i < bc[ip + 3]; i++) {
                params[i] = stack[stack.length - 1 - params[i]];
              }

              stack.splice(stack.length - bc[ip + 2], bc[ip + 2], peg$consts[bc[ip + 1]].apply(null, params));

              ip += 4 + bc[ip + 3];
              break;

            case 27:
              stack.push(peg$parseRule(bc[ip + 1]));
              ip += 2;
              break;

            case 28:
              peg$silentFails++;
              ip++;
              break;

            case 29:
              peg$silentFails--;
              ip++;
              break;

            default:
              throw new Error("Invalid opcode: " + bc[ip] + ".");
          }
        }

        if (ends.length > 0) {
          end = ends.pop();
          ip = ips.pop();
        } else {
          break;
        }
      }

      return stack[0];
    }

    peg$result = peg$parseRule(peg$startRuleIndex);

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail(peg$endExpectation());
      }

      throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse: peg$parse
  };
}();